import './medium-zoom-image.css'
